import { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Divider,
  InputDescription,
  InputTitle,
} from 'components/atoms/styleds';
import TabSwitcher from 'components/molecules/TabSwitcher';
import { deliveryKeys } from 'common/constants/settings';
import SettingsDeliveryLoader from 'components/atoms/Loaders/FormLoaders/SettingsDelivery';
import UIActionsHelper from 'services/UIActionsHelper';
import moment from 'moment';

import OpeningTimes from 'components/molecules/settings/form-contents/OpeningTimes';
import { TimesFormWrapper } from 'components/molecules/settings/styled';

import { Wrapper } from './styled';
import { HeaderTitle } from '../../../organisms/SettingsForm/styled';

const TimesForm = ({
  fetchDeliveryDates,
  deliveryDates,
  onChangeDeliveryTab,
  deliveryActiveTab,
  changeDeliveryDayConfig,
  onChangeMaximum,
  onChangeExceptionDay,
  onAddExceptionData,
  deliveryLoading,
  openingHourErrors,
  setOpeningHourErrors,
  onDeleteException,
  onAddNewException,
  exceptionErrors,
}) => {
  const onSelectDay = useCallback(
    (i) => {
      const currentTabData = deliveryDates[deliveryActiveTab];
      const itemData = UIActionsHelper.getDeliveryHoursItem(
        currentTabData?.opening_hours,
        i?.id,
      );
      const dataForUpdate = {
        day_off: !itemData.day_off,
      };
      if (!dataForUpdate.day_off) {
        dataForUpdate.first_from = null;
        dataForUpdate.first_to = null;
        dataForUpdate.second_from = null;
        dataForUpdate.second_to = null;
      }
      changeDeliveryDayConfig(i.id, dataForUpdate);
      setOpeningHourErrors && setOpeningHourErrors(null);
    },
    [
      deliveryDates,
      deliveryActiveTab,
      changeDeliveryDayConfig,
      setOpeningHourErrors,
    ],
  );

  const onClickCreate = useCallback(
    (i) => {
      const currentData = deliveryDates ? deliveryDates[deliveryActiveTab] : {};
      const findCreatedHours = currentData?.opening_hours?.find((o) => {
        if (o[`${i.key}_from`] && o[`${i.key}_to`]) {
          return true;
        }
      });
      const dataForChange = {
        [`${i.key}_from`]: findCreatedHours
          ? findCreatedHours[`${i.key}_from`]
          : '10:00',
        [`${i.key}_to`]: findCreatedHours
          ? findCreatedHours[`${i.key}_to`]
          : '20:00',
      };
      changeDeliveryDayConfig(i.id, dataForChange);
      setOpeningHourErrors && setOpeningHourErrors(null);
    },
    [
      changeDeliveryDayConfig,
      setOpeningHourErrors,
      deliveryDates,
      deliveryActiveTab,
    ],
  );

  const onDeleteTimeItem = useCallback(
    (i) => {
      const dataForChange = {
        [`${i.key}_from`]: null,
        [`${i.key}_to`]: null,
      };
      changeDeliveryDayConfig(i.id, dataForChange);
      setOpeningHourErrors && setOpeningHourErrors(null);
    },
    [changeDeliveryDayConfig, setOpeningHourErrors],
  );

  const onSelectTime = useCallback(
    (e) => {
      const {
        target: { name, value },
      } = e;
      const [fieldName, itemId] = name.split('-');
      const dataForChange = {
        [fieldName]: value,
      };
      changeDeliveryDayConfig(itemId, dataForChange);
      setOpeningHourErrors && setOpeningHourErrors(null);
    },
    [changeDeliveryDayConfig, setOpeningHourErrors],
  );

  useEffect(() => {
    fetchDeliveryDates(deliveryActiveTab);
  }, [deliveryActiveTab]);

  const onSelectExceptionVariant = useCallback(
    (i, data) => {
      const { id, selectedDay } = i;
      const [key, variant] = id.split('-');
      const date = moment(selectedDay).format('YYYY-MM-DD');

      const dataForChange = {
        ...data,
        day_off: variant === 'on',
        from: '10:00',
        to: '20:00',
        break_from: null,
        break_to: null,
      };
      onAddExceptionData(dataForChange);
      setOpeningHourErrors && setOpeningHourErrors(null);
    },
    [onAddExceptionData, setOpeningHourErrors],
  );

  const onExceptionSelectTime = useCallback(
    (e, data) => {
      const {
        target: { name, value },
      } = e;
      console.log(data, name, value);
      const dataForChange = {
        ...data,
        [name]: value,
      };
      onAddExceptionData(dataForChange);
      setOpeningHourErrors && setOpeningHourErrors(null);
    },
    [deliveryActiveTab, onAddExceptionData, setOpeningHourErrors],
  );

  const onClickExceptionDelete = useCallback(
    (item) => {
      const { id, selectedDay, data } = item;
      let dataForChange = {};
      if (id === 'pause') {
        dataForChange = {
          date: selectedDay,
          day_off: true,
          from: '10:00',
          to: '13:00',
          break_from: null,
          break_to: null,
        };
      } else {
        dataForChange = {
          ...data,
          break_from: null,
          break_to: null,
        };
      }

      onAddExceptionData(dataForChange);
      setOpeningHourErrors && setOpeningHourErrors(null);
    },
    [onAddExceptionData, setOpeningHourErrors],
  );

  const onClickCreatePause = useCallback(
    (item) => {
      const { data } = item;
      const dataForChange = {
        ...data,
        break_from: '15:00',
        break_to: '16:00',
      };
      onAddExceptionData(dataForChange);
      setOpeningHourErrors && setOpeningHourErrors(null);
    },
    [changeDeliveryDayConfig, setOpeningHourErrors],
  );

  const onChangeExceptionsDay = useCallback(
    (d, variant, id) => {
      onChangeExceptionDay(d, variant, id);
      setOpeningHourErrors && setOpeningHourErrors(null);
    },
    [deliveryActiveTab, changeDeliveryDayConfig, setOpeningHourErrors],
  );

  const currentData = deliveryDates[deliveryActiveTab];

  return (
    <Wrapper>
      <HeaderTitle style={{ left: 0, paddingBottom: 8 }} pos='relative'>
        Configura orari di apertura
      </HeaderTitle>
      <InputDescription>
      Inserisci i giorni e gli orari di apertura
      </InputDescription>
      {/* <InputTitle>Imposta i tuoi orari</InputTitle>
      <InputDescription>
        Seleziona i giorni e imposta gli orari in cui i servizi <br /> abilitati
        saranno attivi.
      </InputDescription> */}
      {deliveryLoading ? (
        <SettingsDeliveryLoader />
      ) : (
        <>
          {/* <TabSwitcher
            activeKey={deliveryActiveTab}
            onClick={onChangeDeliveryTab}
            items={[
              { id: deliveryKeys.reservation, label: 'Prenotazione tavoli' },
              { id: deliveryKeys.takeaway, label: 'Asporto' },
              { id: deliveryKeys.delivery, label: 'Delivery' },
            ]}
            maxW='475px'
          /> */}
          <TimesFormWrapper>
            <OpeningTimes
              onSelectTime={onSelectTime}
              onClickCreate={onClickCreate}
              onSelectDay={onSelectDay}
              data={deliveryDates[deliveryActiveTab]}
              variant={deliveryActiveTab}
              onDeleteTimeItem={onDeleteTimeItem}
              onChangeMaximum={onChangeMaximum}
              openingHourErrors={
                openingHourErrors || deliveryDates[deliveryActiveTab]?.errors
              }
              onAddNewException={onAddNewException}
              exceptionErrors={exceptionErrors}
              exceptionProps={{
                data: currentData,
                onSelect: onSelectExceptionVariant,
                onChangeDay: onChangeExceptionsDay,
                // selectedDayFrom: currentData.selectedDayFrom,
                // selectedDayTo: currentData.selectedDayTo,
                selected: [],
                errors: deliveryDates[deliveryActiveTab]?.errors,
                onSelectTime: onExceptionSelectTime,
                onClickDelete: onClickExceptionDelete,
                onClickCreate: onClickCreatePause,
                onDelete: onDeleteException,
              }}
            />
          </TimesFormWrapper>
        </>
      )}
    </Wrapper>
  );
};

TimesForm.propTypes = {
  fetchDeliveryDates: PropTypes.func,
  deliveryDates: PropTypes.shape({}),
  onChangeDeliveryTab: PropTypes.func,
  deliveryActiveTab: PropTypes.oneOf(Object.keys(deliveryKeys)),
  changeDeliveryDayConfig: PropTypes.func,
  deliveryLoading: PropTypes.bool,
};

export default TimesForm;
